var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"notifications"},[_c('transition-group',{attrs:{"name":"list","tag":"div"}},_vm._l((_vm.items),function(item){return _c('Notification',{key:item.id,attrs:{"item":item},on:{"close":_vm.removeItem}},[_vm._v(_vm._s(item))])}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }